/**
 * Get user region using ipinfo API
 */
async function getUserRegion() {
  try {
    console.log('Getting user IP...');
    // Get user's IP
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const { ip } = await ipResponse.json();
    console.log('User IP:', ip);
    
    console.log('Fetching region data from ipinfo...');
    // Get region info from ipinfo
    const token = process.env.NEXT_PUBLIC_IPINFO_TOKEN;
    const regionResponse = await fetch(`https://ipinfo.io/${ip}/json?token=${token}`);
    // const regionResponse = await fetch(`https://ipinfo.io/51.140.0.0/json?token=${token}`); // US IP for testing
    const data = await regionResponse.json();
    console.log('Region data received:', data);
    
    // Format data as requested
    const formattedData = {
      ip: data.ip,
      country: data.country || 'Unknown',
      region: data.region || '',
      city: data.city || '',
      currency: mapCurrency(data.country)
    };
    
    // Store in localStorage
    localStorage.setItem('userRegion', JSON.stringify(formattedData));
    console.log('Region data stored in localStorage:', formattedData);
    
    return formattedData;
  } catch (error) {
    console.error('Error getting user region:', error);
    return null;
  }
}

/**
 * Map country to currency
 */
function mapCurrency(countryCode) {
  const map = {
    PK: 'PKR',
    AE: 'USD',
    SA: 'USD',
    US: 'USD',
  };
  return map[countryCode] || 'USD';
}

export default getUserRegion;
